import { render, staticRenderFns } from "./TypingIcon.vue?vue&type=template&id=1361f590&"
import script from "./TypingIcon.vue?vue&type=script&lang=js&"
export * from "./TypingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports